module.exports = __webpack_public_path__ + "img/sort_sorting.9999dc2e.svg";